export const VERSION = process.env.REACT_APP_VERSION;
export const MOTIVO_CAMBIO_VACIO = '';